<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <!--Filtro años-->
  <app-filters filtros style="width: 500px;"
    [name]="'filtros.per' | translate" [array]="Periodos" [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!-- BORRAR FILTROS -->
  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltro()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="tablaNum1">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-twothird">
          <span class="w3-margin-left-contenido">{{ 'financiero.indicadoresProductividad.tituloTabla1' | translate
            }}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">
            @for (per of subTitles; track per) {
              {{escrituraPer(per)}}
            }
          </span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGrafPrincipal">
            more_vert
          </mat-icon>
          <mat-menu #menuGrafPrincipal="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcelTab1()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="zonaTabla1 w3-scroll">
        @if (dataTabla1.length !== 0) {
          <table class="w3-table borderInf">
            <thead>
              <tr class="w3-center w3-table-title">
                <th class="stikyColum w3-elemento-titulo-table w3-border-right-balance">
                  <span class="w3-elemento-titulo-table">
                    {{'financiero.indicadoresProductividad.titTabla2' | translate}}
                  </span>
                </th>
                @if (dataTabla1[0].valor.length!==0) {
                  @for (val of dataTabla1[0].valor; track val) {
                    <th class="columMes stikyColum w3-border-right-balance">
                      <span style="margin-right: 5%;">{{escrituraPer(val.name)}}</span>
                    </th>
                  }
                }
              </tr>
            </thead>
            @for (item of dataTabla1; track item; let i = $index) {
              @if (item.check){
                <tbody>
                  <tr class="w3-table-trtd">
                      <td class="estiloNivel2 borderAllLow textoOverFlow" [ngClass]="{'selection' : indSelec === item.nombre}"
                        (click)="changeGrafic1(tipoGraf, dataTabla1Periodos[i], dataTabla1[i].nombre, true)">
                        @if (item.nivel === 1) {
                          <mat-icon class="iconoMen">
                            {{item.dbCheck?'expand_less':'expand_more'}}
                          </mat-icon>
                        }@else {
                          <mat-icon class="iconoMen">
                            remove
                          </mat-icon>
                        }
                        <span class="w3-elemento-tableIndicador" matTooltip="{{item.descripcion}}">{{item.nombre}}</span>
                      </td>

                      @if (item.valor.length!==0) {
                        @for (val of item.valor; track val) {
                          <td class="columMes borderAllLow alinRight estiloNivel2"
                            [ngClass]="{'selection' : indSelec === item.nombre}"
                            (click)="changeGrafic1(tipoGraf, dataTabla1Periodos[i], dataTabla1[i].nombre, true)">
                            <span class="w3-elemento-tableIndicador" style="margin-right: 5%;">{{val.valor | formaterNumber:0:miles:decimal}}</span>
                          </td>
                        }
                      }
                    <!-- @if (headersCheck[2].check) {
                      <td class="estiloNivel2 borderAllLow textoOverFlow" [ngClass]="{'selection' : indSelec === item.nombre}"
                        (click)="changeGrafic1(tipoGraf, dataTabla1Periodos[i], dataTabla1[i].nombre)">
                        <span class="w3-elemento-tableIndicador">{{item.descripcion}}</span>
                      </td>
                    } -->
                  </tr>
                </tbody>
              }
            }
          </table>
        }@else {
          <app-skeleton-table [columnas]="7" [filas]="7"/>
        }
      </div>
    </div>
    <div class="tablaNum2" id="graficaSup">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-noventa">
          <span class="w3-margin-left-contenido">{{ 'financiero.indicadoresProductividad.tituloTabla11' | translate
            }}</span>
          @if (verGraf) {
            <span> | {{ indSel1 }}</span>
          }
          <span class="w3-margin-left-filter w3-subtitulo">
            @for (per of subTitles; track per) {
              {{escrituraPer(per)}}
            }
          </span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="showLabels = !showLabels" matTooltip="{{'tooltips.tooltipIcono7'|translate}}">
            {{ showLabels ? 'label_off' : 'label' }}
          </mat-icon>
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="openModal('graf1')" matTooltip="{{'financiero.indicadoresProductividad.tooltipIcono2'|translate}}">
            zoom_out_map
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGraf">
            more_vert
          </mat-icon>
          <mat-menu #menuGraf="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuTable">
              <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              <span>{{'financiero.indicadoresProductividad.tooltipIcono3'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item
              (click)="exportarGrafica(1, 'financiero.indicadoresProductividad.tituloTabla11')">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #menuTable="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'line'}"
              [disabled]="tipoGraf == 'line'" (click)="changeGrafic1('line', datoGraf, indSelec)">
              <!--[matMenuTriggerFor]="menuIndLin"-->
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'financiero.indicadoresProductividad.tooltipIcono5'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar'}"
              [disabled]="tipoGraf == 'bar'" (click)="changeGrafic1('bar', datoGraf, indSelec)">
              <!--[matMenuTriggerFor]="menuIndBar"-->
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'financiero.indicadoresProductividad.tooltipIcono4'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'area'}"
              [disabled]="tipoGraf == 'area'" (click)="changeGrafic1('area', datoGraf, indSelec)">
              <!--[matMenuTriggerFor]="menuIndBar"-->
              <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
              <span>{{'financiero.indicadoresProductividad.tooltipIcono8'|translate}}</span>
            </button>
          </mat-menu>
          <mat-menu #menuIndLin="matMenu">
            @for (item of dataTabla1Periodos; track item; let i = $index) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item
                (click)="changeGrafic1('line', item, dataTabla1[i].nombre)">
                @if (i < 9) {
                  <span class="w3-elemento-tableIndicador">{{'CR_0'+(i+1)}}</span>
                }
                @if (i >= 9) {
                  <span class="w3-elemento-tableIndicador">{{'TC_'+(i+1)}}</span>
                }
              </button>
            }
          </mat-menu>
          <mat-menu #menuIndBar="matMenu">
            @for (item of dataTabla1Periodos; track item; let i = $index) {
              <button class="mat-menu-item w3-caja-menu" mat-menu-item
                (click)="changeGrafic1('bar', item, dataTabla1[i].nombre)">
                @if (i < 9) {
                  <span class="w3-elemento-tableIndicador">{{'CR_0'+(i+1)}}</span>
                }
                @if (i >= 9) {
                  <span class="w3-elemento-tableIndicador">{{'TC_'+(i+1)}}</span>
                }
              </button>
            }
          </mat-menu>
        </div>
      </div>
      <div class="zonaTabla2">
        @if(dataGrafica.length > 0){
          <app-graficador #graficador1 [data]="dataGrafica" [labels]="labelsGrafica" [type]="tipoGraf" [colors]="color"
            [axisY]="['Valor']" [axisX]="'Periodos'" [zona]="1" [formatEtiquetas]="true" [etiquetas]="showLabels"
            [legend]="{enabled: false, position: 'bottom'}">
          </app-graficador>
        }@else {
          <app-skeleton-grafica [barras]="4"/>
        }        
      </div>
    </div>
  </div>
</app-esqueleto-tableros>
<!-- MODALES -->
 <app-modal [isOpen]="modalOpen" (close)="modalOpen = false; graf1 = false;">
  <div modal-header>
        <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-half w3-white">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu  hijoizquierdaTitle">
            @if (graf1) {
              <span class="w3-margin-left-contenido">{{
                'financiero.indicadoresProductividad.tituloTabla1' | translate }} | {{ indSel1 }}</span>
            }
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">
              @for (per of subTitles; track per) {
                {{escrituraPer(per)}}
              }
            </span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <!-- Icono de etiquetas para modal -->
          @if(graf1){
            <mat-icon class="w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
              (click)="showLabels = !showLabels" [matTooltip]="showLabels ? ('graf.desactivar'|translate) : ('graf.activar' | translate)">
              {{ showLabels ? 'label_off' : 'label'}}
            </mat-icon>
          }          
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGrafica(1, 'financiero.indicadoresProductividad.tituloTabla11')" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body>
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%; height: 60vh;">
      @if (graf1) {
        <div class="w3-row contentGraf" style="height: 100%; width: 100%;">
          <app-graficador #graficador3 [data]="dataGrafica" [labels]="labelsGrafica" [type]="tipoGraf" [colors]="color"
            [axisY]="['Valor']" [axisX]="'Periodos'" [zona]="2" [formatEtiquetas]="true" [etiquetas]="showLabels"
            [legend]="{enabled: true, position: 'right'}">
          </app-graficador>
        </div>
      }
    </div>
  </div>
 </app-modal>